let prefix_local_all_notifications = `${APIPrefix.get()}/api/notifications`;
let prefix_local_archived_notification = `${APIPrefix.get()}/api/notifications/archived`;
let prefix_local_post_archive_notification = `${APIPrefix.get()}/api/notifications/archive`;

const PAGE_NOTIFICATIONS_DASHBOARD = document.querySelector(
  '#notifications-page'
);

if (PAGE_NOTIFICATIONS_DASHBOARD) {

    const getNotifications = async (type, devId) => {
        let endpoint = `${prefix_local_all_notifications}`;
        if (type === 'archived') {
            endpoint = `${prefix_local_archived_notification}?developmentId=${devId}`;
        }
        let response;
        response = await fetch(endpoint);
        if (response.status == 200) {
             let data = await response.json();
             if (data.status === '401') {
                APIUtils.redirectUserToSigninPage();
            } else {
                return data;
              }
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    const selectFirstTab = () => {
        const TAB_COMPONENT_NOTIFICATION = document.querySelectorAll('.tab-component-notification');
        TAB_COMPONENT_NOTIFICATION.forEach((tabComp) => {
            const FIRST_TAB_NOTIFICATION = tabComp.querySelector('.tab-item-link-notification').firstElementChild;
            const FIRST_CONTENT_NOTIFICATION = tabComp.querySelector('.tab-content-wrapper-notification').firstElementChild;
            FIRST_TAB_NOTIFICATION.click();
            FIRST_CONTENT_NOTIFICATION.click();
        });
    };

    const addListenerToTab = () => {
        // logic for tabs on notifications
        const TAB_COMPONENT_NOTIFY = document.querySelectorAll('.tab-component-notification');
        if (TAB_COMPONENT_NOTIFY) {
            TAB_COMPONENT_NOTIFY.forEach((tabComp) => {
                const TAB_ITEM_LINK_NOTIFY = tabComp.querySelector('.tab-item-link-notification');
                const TAB_CONTENT_WRAPPER_NOTIFY = tabComp.querySelector('.tab-content-wrapper-notification');
                //make first tab and content visible on page load
                if (TAB_ITEM_LINK_NOTIFY && TAB_CONTENT_WRAPPER_NOTIFY) {
                    const FIRST_TAB_NOTIFY = tabComp.querySelector('.tab-item-link-notification').firstElementChild;
                    const FIRST_CONTENT_NOTIFY = tabComp.querySelector('.tab-content-wrapper-notification').firstElementChild;
                    FIRST_TAB_NOTIFY.click();
                    FIRST_CONTENT_NOTIFY.click();
                }

                //handle tab functionality on click for every tab item
                let handleClickNotification = (e) => {
                    Array.from(e.target.parentElement.parentElement.querySelectorAll('.active'), (e) =>
                    e.classList.remove('active')
                    ); // remove `active` class from every elements which contains him.
                    e.target.classList.add('active');
                    document.querySelector(`div.tab-item-content-notification[data-id*="${e.target.dataset.id}"]`).classList.add('active');

                    if (e.target.dataset.id.includes('all')) {
                        let developementId = e.target.dataset.id.replace('all', '');
                        let currentList = document.querySelector(`#list-archive-${developementId}`);
                        currentList.innerHTML = '';
                    }

                };
                Array.from(document.querySelectorAll('.tab-component-notification .tablinks'), (btn) =>
                    btn.addEventListener('click', handleClickNotification, false)
                );
            });
        }
    };

    const addListenerToArchiveTab = () => {
        const ARCHIVE_TABS_NOTIFY = document.querySelectorAll('.tab-item-link-notification .list-archive');
        if (ARCHIVE_TABS_NOTIFY) {
            ARCHIVE_TABS_NOTIFY.forEach((archiveTab) => {
                let handleArchiveNotification = (e) => {
                    let developementId = e.target.dataset.id.replace('archived', '');
                    let currentList = document.querySelector(`#list-archive-${developementId}`);
                    if (currentList.innerText === '') {
                        getArchiveNotification("archived", developementId, currentList);
                    }
                };
                archiveTab.addEventListener('click', handleArchiveNotification, false);
            });
        }
    };

    const populateTabAllNotification = (data) => {
        let currentList = document.querySelector(`#ulall${data.developmentId}`);
        if (data.notifications.length) {
            data.notifications.forEach(element => {
                renderNotification(currentList, element, "all");
            });
        } else {
            let notifyNoDataAll = document.querySelector('#notify-no-data-all').value;
            currentList.innerHTML = `<li>${notifyNoDataAll}</li>`;
        }

    };

    const getNotificationsApi =  async function(type) {
        getNotifications(type).then((resp) => {
            document.querySelector('#notificationsModal .modal-body .loading').style.display = 'block';
            if (resp.status === 'success') {
                document.querySelector('#notificationsModal .modal-body .wrapper-developments').style.display = 'block';
                let counterNotification = 0;

                let notifyNoDataAll = document.querySelector('#notify-no-data-all').value;

                if (resp.data.items.length) {
                    for (let index = 0; index < resp.data.items.length; index++) {
                        const element = resp.data.items[index];

                        const titleTabArchive = document.querySelector('#notify-tab-archive').value;
                        const titleTabAll = document.querySelector('#notify-tab-all').value;

                        document.querySelector('.wrapper-developments').innerHTML += `
                            <div id="wrapper-${element.developmentId}">
                                <h2>${element.developmentName}</h2>

                                <div class="tab-component-notification">
                                    <div class="tab-item-link-notification">

                                        <button class="tablinks" data-id="all${element.developmentId}">${titleTabAll}</button>
                                        <button class="tablinks list-archive" data-id="archived${element.developmentId}">${titleTabArchive}</button>
                                    </div>

                                    <div class="tab-content-wrapper-notification">
                                        <div data-id="all${element.developmentId}" class="tab-item-content-notification">
                                           <ul class="list-notifications" id="ulall${element.developmentId}"></ul>
                                        </div>

                                        <div data-id="archived${element.developmentId}" class="tab-item-content-notification">
                                            <ul class="list-notifications" id="list-archive-${element.developmentId}"></ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        `;
                        populateTabAllNotification(element);
                        counterNotification += element.notifications.length;
                    }
                    addListenerToTab();
                    selectFirstTab();
                    addListenerToArchiveTab();
                    addEventToArchive();
                } else {
                    document.querySelector('.wrapper-developments').innerHTML += `<p>${notifyNoDataAll}</p>`;
                }
                populateCounterNumber(counterNotification);
            } else {
                document.querySelector('#notificationsModal .modal-body .rest-fail').style.display = 'block';
            }
            document.querySelector('#notificationsModal .modal-body .loading').style.display = 'none';
        }).catch((e)=>{
            let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : "";
            document.querySelector('#notificationsModal .modal-body .rest-fail').innerText = msg;
            document.querySelector('#notificationsModal .modal-body .rest-fail').style.display = 'block';
            document.querySelector('#notificationsModal .modal-body .wrapper-developments').style.display = 'none';
            document.querySelector('#notificationsModal .modal-body .loading').style.display = 'none';
        });

        return;
    };

    const populateCounterNumber = (counter) => {
        document.querySelectorAll('.notificationsModal .counter-loading').forEach((c) => {
            c.style.display = 'none';
        });
        document.querySelectorAll('.notificationsModal .counter').forEach((c) => {
            c.innerText = counter;
            c.style.display = 'inline-block';
        });
    };

    const decrementCounterNotifications = (counter) => {
        document.querySelectorAll('.notificationsModal .counter').forEach((c) => {
            c.innerText = counter-1;
        });
    };

    const renderNotification = (currentList, notification, type) => {
        let developmentId = type !== 'archived' ? currentList.getAttribute('id').replace('ulall', '') : currentList.getAttribute('id').replace('list-archive-', '');

        let tooltipRemove = document.querySelector('#notify-tooltip-remove').value;
        let tooltipGo = document.querySelector('#notify-tooltip-go').value;

        currentList.innerHTML += `
            <li data-developementId="${developmentId}" data-id="${notification.id}" id="notify${notification.id}">
            <span class="icon ${notification.action ? 'icon-action' : 'icon-message'}">&nbsp;</span>
            <span class="title">${notification.message}</span>
            <span class="actions">
                ${notification.action ? `<a tabindex="0" href="${notification.url}" title="${tooltipGo}" class='go button button--primary'>GO</a>` : ''}
                ${type !== "archived" ? `<span tabindex="0" title="${tooltipRemove}" class='archive button button--primary'>X</span>` : ''}
            </span>
            </li>
        `;
    };

    const checkDevHasNotification = (developementId) => {
        // remove wrapper if no notification

        if (document.querySelector(`#ulall${developementId} li`) == null) {
            let notifyNoDataAll = document.querySelector('#notify-no-data-all').value;
            document.querySelector(`#ulall${developementId}`).innerHTML = `<li>${notifyNoDataAll}</li>`;
        }
        // update counter here
        let currentValueCounter = +document.querySelector('.notificationsModal .counter').innerText;
        decrementCounterNotifications(currentValueCounter, 'decrement');
    };

    const postArchiveNotification = async function (id) {
          let response;
          response = await fetch(
            `${prefix_local_post_archive_notification}?notificationId=${id}`,
            {
              method: 'POST',
              headers: {
                'Content-type': 'application/json',
              },
            }
          );
            if (response.status == 200) {
              let data = await response.json();
              if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
              } else {
                return data;
              }
            } else {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    };

    const addEventToArchive = () => {
        let handleArchiveNotification = (e) => {
            e.preventDefault();
            if (e.keyCode === 13 || e.type === 'click') {
                let notificationId = e.target.parentNode.parentNode.getAttribute('data-id');
                let developementId = e.target.parentNode.parentNode.getAttribute('data-developementId');

                postArchiveNotification(notificationId).then((data) => {
                    if (data.status === 'success') {
                            document.querySelector(`#notify${notificationId}`).remove();
                            checkDevHasNotification(developementId);
                    } else {
                        let msg = data.message;
                        document.querySelector('#notificationsModal .modal-body .rest-fail').innerText = msg;
                        document.querySelector('#notificationsModal .modal-body .rest-fail').style.display = 'block';
                        document.querySelector('#notificationsModal .modal-body .wrapper-developments').style.display = 'none';
                        document.querySelector('#notificationsModal .modal-body .loading').style.display = 'none';
                    }
                }).catch((e)=>{
                        let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : "";
                        document.querySelector('#notificationsModal .modal-body .rest-fail').innerText = msg;
                        document.querySelector('#notificationsModal .modal-body .rest-fail').style.display = 'block';
                        document.querySelector('#notificationsModal .modal-body .wrapper-developments').style.display = 'none';
                        document.querySelector('#notificationsModal .modal-body .loading').style.display = 'none';
                });
            }
        };
        Array.from(document.querySelectorAll('#notificationsModal .archive'), (btn) => {
            btn.addEventListener('keyup', handleArchiveNotification, false);
            btn.addEventListener('click', handleArchiveNotification, false);
        });
    };


    const getArchiveNotification = (type, devId, currentList) => {
        currentList.innerHTML += `<div class='list-loader'></div>`;

        getNotifications(type, devId).then((resp) => {
            if (resp.status === 'success') {
                if (resp.data.items.length) {
                    let currentNotification = resp.data.items[0].notifications; //for local api
                    if(currentNotification.length){
                        currentNotification.forEach(element => {
                            renderNotification(currentList, element, "archived");
                        });
                    }else{
                        let notifyNoDataArchived = document.querySelector('#notify-no-data-archived').value;
                        currentList.innerHTML = `<li>${notifyNoDataArchived}</li>`;
                    }
                } else {
                    let notifyNoDataArchived = document.querySelector('#notify-no-data-archived').value;
                    currentList.innerHTML = `<li>${notifyNoDataArchived}</li>`;
                }

            } else {
                currentList.innerHTML += `<li>${resp.message}</li>`;
            }
            if(currentList.querySelector('.list-loader')){
                currentList.querySelector('.list-loader').style.display = 'none';
            }
        }).catch((e)=>{
            console.log('Catch error::', e);
            let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : "";
            currentList.innerHTML += `<li>${msg}</li>`;
            if(currentList.querySelector('.list-loader')){
                currentList.querySelector('.list-loader').style.display = 'none';
            }
        });

    };

    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
            getNotificationsApi("all");
        }, "1000");
    });
}